export const QUIZ = {
    GET_QUIZ_TRANSACTION: "quiz/GET_QUIZ_TRANSACTION",
    GET_MEMBER_QUIZ_DETAIL: "quiz/GET_MEMBER_QUIZ_DETAIL",
    SELECT_MEMBER_QUIZ_DETAIL: "quiz/SELECT_MEMBER_QUIZ_DETAIL",
    CLEAR_MEMBER_QUIZ_DETAIL: "quiz/CLEAR_MEMBER_QUIZ_DETAIL",
    SET_SCORE: "quiz/SET_SCORE",
};
